/**
 * Card Registration API Handler
 */
export default class CardRegistrationAPI {
    constructor() {
        this.namespace = 'cancan/card-registration/v1';
        this.baseUrl = window.wpApiSettings?.root || '/wp-json/';
        this.nonce = window.wpApiSettings?.nonce || '';
        this.isLocked = false;
    }

    /**
     * Lock the API handler to prevent any further network requests.
     */
    lock() {
        this.isLocked = true;
    }

    /**
     * Generic request handler
     */
    async request(path, options = {}) {
        if (this.isLocked) {
            console.warn(`[API] Request to ${path} blocked: API is locked after success.`);
            return Promise.resolve({ success: true, body: { Status: 'OK' } });
        }
        const { method = 'GET' } = options;
        const url = this.baseUrl + this.namespace + path;

        const headers = {
            'Content-Type': 'application/json',
            ...(this.nonce ? { 'X-WP-Nonce': this.nonce } : {}),
            ...options.headers,
        };

        console.log(`[API Request] ${method} ${path}`, options.body ? JSON.parse(options.body) : '');

        const response = await fetch(url, { ...options, headers });
        const data = await response.json();

        console.log(`[API Response] ${response.status}`, data);

        if (!response.ok) {
            throw new Error(data.message || 'API Error');
        }
        return data;
    }

    /**
     * Check if card exists
     */
    checkCard(cardNumber) {
        const params = new URLSearchParams({ 'card-number': cardNumber });
        return this.request(`/check?${params.toString()}`);
    }

    /**
     * Get card information
     */
    getCardInfo(cardNumber) {
        const params = new URLSearchParams({ 'card-number': cardNumber });
        return this.request(`/card-info?${params.toString()}`);
    }

    /**
     * Verify 6-digit code
     */
    verifyCode(code, phone) {
        return this.request('/verify-code', {
            method: 'POST',
            body: JSON.stringify({ code, phone }),
        });
    }

    /**
     * Send initial verification code
     */
    sendCode(phone, name) {
        return this.request('/send-code', {
            method: 'POST',
            body: JSON.stringify({ phone, name }),
        });
    }

    /**
     * Register a new card
     */
    register(data) {
        return this.request('/register', {
            method: 'POST',
            body: JSON.stringify(data),
        });
    }
}
